export enum ENotificationDB {
  ANIMAL_APPLICATION_APPROVED = 'animalApplicationApproved',
  ANIMAL_APPLICAION_REJECTED = 'animalApplicationRejected',
}

export enum ENotificationUI {
  ANIMAL_APPLICATION_APPROVED = 'animalApplicationApproved',
  ANIMAL_APPLICAION_REJECTED = 'animalApplicationRejected',
}
